import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Download
 * @exports Service/Cms/ConsumerDutyResource
 * @description API Download Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class ConsumerDutyResource {
	/**
	 * @static @name list
	 * @description Get all downloads as a list that can be manipulated through post body properties
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			`cms/consumer-duty-resource/list`,
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-consumer-duty-resource-${cacheHash}`
			}
		);
	}
}
